import { h } from 'preact'; /** @jsx h */
import formatPrice from '../../utils/formatPrice';

import './Checkout.scss';

const Checkout = ({ isTablet, total, handleCheckout, setTabletView }) => {
    return (
        <div className="ws-order-user-info">
            <div className="user-info-content checkout">
                <div className="total-price-heading">
                    <h4>Å betale: </h4>
                    <h4>Kr. {formatPrice(total)},-</h4>
                </div>
                <form id="checkoutForm" method="post" action="/medl/nettbutikk_order_create.php">
                    <button className="ws-order-btn" onClick={e => handleCheckout(e)}>
                        Gjennomfør betaling
                    </button>
                </form>
                {isTablet && (
                    <button className="ws-back-btn" onClick={() => setTabletView('cart')}>
                        <span className="material-symbols-outlined icon">chevron_left</span>
                        Tilbake til handlevogn
                    </button>
                )}
            </div>
        </div>
    );
};

export default Checkout;
